// Multicolumn Section - Mobile Slider

// Main initialization function (extracted for reuse in theme editor)
window.initMulticolumnSlider = function (section) {
    if (!section) return null;

    const sliderElement = section.querySelector('.js-multicolumn-slider');
    if (!sliderElement) return null;

    const blockCount = parseInt(section.dataset.blockCount || '0');
    const hideSliderArrows = sliderElement.dataset.hideSliderArrows === 'true';
    let mainSplide = null;

    // Slider is only active on mobile (< 768px)
    const shouldEnableSlider = () => {
        return window.innerWidth < 768;
    };

    // Initialize slider
    mainSplide = window.SplideUtils.initSplideWithControls(
        sliderElement,
        section,
        {
            type: 'carousel',
            rewind: true,
            perPage: 1,
            perMove: 1,
            gap: '16px',
            padding: { left: 0, right: 0 },
            arrows: false,
            pagination: false,
            drag: shouldEnableSlider(),
            breakpoints: {
                767: {
                    gap: '16px',
                    padding: { right: '25%' },
                    drag: true,
                },
                550: {
                    gap: '16px',
                    padding: { right: '20%' },
                    drag: true,
                }
            },
            i18n: {
                prev: 'Previous slide',
                next: 'Next slide',
                first: 'Go to first slide',
                last: 'Go to last slide',
                slideX: 'Go to slide %s',
                pageX: 'Go to page %s',
            },
        },
        {
            customArrows: !hideSliderArrows,
            scrollbar: true,
            tabindex: true
        }
    );

    // Update slider state based on screen size
    const updateSlider = () => {
        if (!mainSplide) return;

        const shouldEnable = shouldEnableSlider();

        if (shouldEnable) {
            section.classList.add('slider-active');
            mainSplide.options.drag = true;
            mainSplide.refresh();
        } else {
            section.classList.remove('slider-active');
            mainSplide.options.drag = false;
            mainSplide.go(0);
            mainSplide.refresh();
        }
    };

    // Initial setup
    updateSlider();

    // Handle resize
    let resizeTimeout;
    const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateSlider, 250);
    };
    window.addEventListener('resize', handleResize);

    return mainSplide;
};

// Initialize all multicolumn sliders on page load
function initAllMulticolumnSliders() {
    const sections = document.querySelectorAll('.multicolumn-section');
    sections.forEach((section) => {
        window.initMulticolumnSlider(section);
    });
}

// Run on DOMContentLoaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMulticolumnSliders);
} else {
    initAllMulticolumnSliders();
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        if (event.target.classList.contains('multicolumn-section')) {
            // Small delay to ensure DOM is ready
            setTimeout(() => {
                window.initMulticolumnSlider(event.target);
            }, 100);
        }
    });

    document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.classList.contains('multicolumn-section')) {
            const sliderElement = event.target.querySelector('.js-multicolumn-slider');
            if (sliderElement && sliderElement.splide) {
                sliderElement.splide.destroy();
            }
        }
    });

    // Handle block reordering
    document.addEventListener('shopify:block:select', function (event) {
        const section = event.target.closest('.multicolumn-section');
        if (section) {
            const sliderElement = section.querySelector('.js-multicolumn-slider');
            if (sliderElement && sliderElement.splide) {
                sliderElement.splide.refresh();
            }
        }
    });
}
